import Pusher from 'pusher-js';

const pusher = new Pusher('8efd86937d27057c2e8c', {
  cluster: 'us3'
});


export const orderChannel = pusher.subscribe(process.env.REACT_APP_CHANNEL);